import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("stratedge-lang") || "en");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("stratedge-lang", lang);
  }, [lang]);

  const t = useCallback(
    (key) => translations[lang]?.[key] ?? translations.en[key] ?? key,
    [lang]
  );

  const pick = useCallback(
    (obj, base) => (obj ? obj[`${base}_${lang}`] || obj[`${base}_en`] || "" : ""),
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, isRTL: lang === "ar", t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
